//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, onMounted } from '@nuxtjs/composition-api';
import SfFooter from '~/themes/fiskarsMoominDefault/components/components/organisms/SfFooter/SfFooter.vue';
import SfList from '~/themes/fiskarsMoominDefault/components/components/organisms/SfList/SfList.vue';
import SfMenuItem from '~/themes/fiskarsMoominDefault/components/components/molecules/SfMenuItem/SfMenuItem.vue';
import SfHeading from '~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue';
import MoominLink from '~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue';
import MoominFooterCopyright from "./MoominFooterCopyright.vue";

export default defineComponent({
  name: "MoominFooter",
  components: { SfFooter, SfList, SfMenuItem, SfHeading, MoominLink, MoominFooterCopyright},
  props: {
    footerLinksGroup: {
      type: Array,
      default: () => []
    },
    paymentMethods: {
      type: Object,
      default: () => ({})
    },
    deliveryPartners: {
      type: Object,
      default: () => ({})
    },
    socialMedia: {
      type: Object,
      default: () => ({})
    },
    copyright: {
      type: String,
      default: ""
    }
  },
  methods: {
    getItemLink(item) {
      if(item.link === 'ot-sdk-show-settings') return ''

      return item.linkUrl && item.linkUrl!= '' ? item.linkUrl : this.localePath(item.link)
    }
  },
  setup() {
    onMounted(() => {
      if (window.OneTrust != null) {
        OneTrust.initializeCookiePolicyHtml();
      }
    })
  }
})
